export default {
  title: 'Für wen ist die Bestellung gedacht? 😊',
  description: 'Das hilft uns, ein reibungsloses Erlebnis zu schaffen.',
  form: {
    first_name: {
      placeholder: 'Vorname',
    },
  },
};